// @ts-nocheck
import { defineComponent } from "vue"
import download_url from "../../../files/actions/download_url"
import component from "../../../legacy/unavailable-message"
import navigate from "../../navigate"

export default defineComponent({
  extends: component,
  methods: {
    initial_action() {
      download_url(this.imposition_url.replace(/\/json\//g, "/pdf/"))
      navigate()
    },
  },
  props: ["imposition_url"],
})
